import {
  call,
  fork,
  select,
//  put,
  takeLatest
} from 'redux-saga/effects';
//import { delay } from 'redux-saga';
import loader from '../../../../../util/loader/loader';
import dataProvider from '../../../../../util/dataProvider/dataProvider';
import {
  navigationRoutes,
  navigationSteps,
  buyFlowUrls
} from '../../../navigation/navigationHelpers';
import {
  LOAD_CONTENT
} from './upsell';

/*import {
  productNameSelector,
  setQuickCheckoutData
 } from '../../../data/quickCheckout/quickCheckout';*/
//import {NORMALIZE_DATA} from '../../../dataProvider/dataProvider';
import {
  errorPageByFlow
  //hideGlobalSpinner
} from '../../../common/common';

/*import {
  shoppingElementIdSelector,
  priceReferenceIdSelector,
  setData,
  setProductId
} from '../../../data/checkout/checkout';*/

// WATCHERS
export function* loadContentWatch() {
  yield takeLatest(LOAD_CONTENT, loadContentWorker);
}

/*export function* normalizeWatch() {
  yield takeLatest(NORMALIZE_DATA, normalizeWorker);
}*/

// WORKERS
export function* loadContentWorker() {
  try {
    const buyflowConsumerType = 'StreamingVideo';
    const errorPage = yield select(errorPageByFlow);
    const addDefaultOfferEndpoint = navigationRoutes[navigationSteps.myPlan.OFFERS].endpoints.addDefaultOfferToCart();
    const defaultOfferData = {buyflowConsumerType};
    const checkEligibilityEndpoint = navigationRoutes[navigationSteps.myPlan.ADDON_CHANNEL].endpoints.checkEligibility(buyflowConsumerType);
    const AddProductToCartEndpoint = navigationRoutes[navigationSteps.myPlan.UPSELL_STREAMING_VIDEO].endpoints.addToCart();

    const success = yield call(dataProvider.load, [
      {state: 'auth'},
      {state: 'customer'},
      {state: 'offers', param: ''}
    ], {errorPage});

    if (!success) {
      return;
    }

    yield call(loader.request, addDefaultOfferEndpoint, {data: defaultOfferData, useGlobalSpinner: false});

    const eligibility = yield call(loader.request, checkEligibilityEndpoint, {useGlobalSpinner: false});
    const addProductToCartData = {
      ...defaultOfferData,
      offerId: eligibility.priceReferenceId
    };

    yield call(loader.request, AddProductToCartEndpoint, {data: addProductToCartData, useGlobalSpinner: false});

    window.location.replace(buyFlowUrls.CUSTOMIZE);
  } catch(e) {
    //console.log(e)
  }
}

/*export function* normalizeWorker({key, data, meta}) {
  if (key !== 'productMapping' && key !== 'productForQuickcheckout' && key !== 'customerLobAndProduct') {
    return;
  }

  if (key === 'productMapping') {
    yield put(setData({
      ...meta,
      content: data
    }));
    yield put(setQuickCheckoutData({
      productId: data.shoppingElementId,
      productName: data.productName
    }));
  } else {
    yield put(setProductId(data.priceReferenceId));
  }
}*/

export default function* upsellSagas() {
  yield [
    fork(loadContentWatch)
    //fork(normalizeWatch)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/MyPlan/upsell/upsellSagas.js
 **/